export const initialState = {
    filterActive: false,
    isSet: {
        search: false,
        projects: true,
        tags: false,
        groups: false,
    },
    searchTerm: '',
    projects: [],
    groups: [],
    selected: {
        projects: undefined,
        tags: undefined,
        groups: undefined,
    },
    tags: [],
    clustering: {
        schools: false,
        support: false,
    },
};

// Get DOM elements
export const spinner = document.querySelector('#lmz-loading');
export const resetFilterBtn = document.querySelector('#lmz-reset-filter');
export const resetMapBtn = document.querySelector('#lmz-reset-map');
export const searchInput = document.querySelector('#lmz-search');
export const tagInput = document.querySelector('#lmz-tags');
export const projectInputs = document.querySelectorAll('.form-check-project');
export const groupInputs = document.querySelectorAll('.form-check-group');
export const allProjects = document.querySelector('#all-projects');
export const allGroups = document.querySelector('#all-groups');

/**
 * Return proper API base URL based on local/live
 *
 * @returns String
 */
export function getApiUrl() {
    if (window.location.href.includes('localhost')) {
        return 'https://lmz-bw.ddev.site';
    } else {
        return 'https://cms.bildungbw.de';
    }
}
